  
 

import { createRouter, createWebHistory } from 'vue-router';
import dashboard from '../components/pages/dashboard.vue'
import ViewAds from "../components/pages/ViewAds.vue"
import NotFound from '@/components/pages/NotFound.vue';
import axios from 'axios';
import { trackInteraction } from '@/utils/trackInteraction';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // Directory ("More ▾") — placed before citywise dynamic route so /more/* wins.
    // Static segments (/new, /edit) come BEFORE the generic :slug match.
    {
      path: '/more/:category/new',
      name: 'directory-create',
      component: () => import('../components/pages/Directory/DirectoryListingForm.vue'),
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/more/:category/:slug/edit',
      name: 'directory-edit',
      component: () => import('../components/pages/Directory/DirectoryListingForm.vue'),
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/more/:category',
      name: 'directory-list',
      component: () => import('../components/pages/Directory/DirectoryListPage.vue'),
      meta: { public: true },
      props: true,
    },
    {
      path: '/my-listings',
      name: 'my-directory-listings',
      component: () => import('../components/pages/Directory/MyDirectoryListings.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/more/:category/:slug',
      name: 'directory-detail',
      component: () => import('../components/pages/Directory/DirectoryDetailPage.vue'),
      meta: { public: true },
      props: true,
    },

    // Deals — static segments (/new, /:slug/edit) BEFORE the generic :slug match.
    // Placed before the greedy citywise /:subtype/:city route so /deals/* wins.
    {
      path: '/deals/new',
      name: 'deal-create',
      component: () => import('../components/pages/Deals/DealForm.vue'),
      // Public route: the form self-gates with the login popup (see DealForm
      // created()) so logged-out users get the modal instead of a silent bounce.
      meta: { public: true },
    },
    {
      path: '/deals/:slug/edit',
      name: 'deal-edit',
      component: () => import('../components/pages/Deals/DealForm.vue'),
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/deals',
      name: 'deals-list',
      component: () => import('../components/pages/Deals/DealsListPage.vue'),
      meta: { public: true },
    },
    {
      path: '/my-deals',
      name: 'my-deals',
      component: () => import('../components/pages/Deals/MyDeals.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/deals/:slug',
      name: 'deal-detail',
      component: () => import('../components/pages/Deals/DealDetailPage.vue'),
      meta: { public: true },
      props: true,
    },

    // Dynamic citywise route for SEO and metadata
    {
      path: '/:subtype/:city',
      name: 'citywise-page',
      component: () => import('../components/pages/CitywisePage.vue'),
      meta: { public: true },
      props: true
    },

    {
      path: '/dashboard',
      component: dashboard,
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: () => import('../components/pages/dashboard.vue'),
          meta: {
            public: true
          },
          props: true
        }
      ]
    },

    {
      path: '/crawl-report',
      name: 'crawl-report',
      component: () => import('../components/pages/CrawlDataReport.vue'),
      meta: { requiresAdmin: true },
      props: true
    },

//     {
//   path: '/',
//   redirect: '/dashboard'
// },

//     {
//   path: '/dashboard',
//   name: 'dashboard',
//   component: () => import('../components/pages/dashboard.vue'),
//   meta: { public: true },
//   props: true
// },
// OAuth callback routes are handled by the backend server (proxied via /auth)
// Do NOT add Vue routes for /auth/google/callback or /auth/facebook/callback
   {
  path: '/reset-password',
  name: 'reset-password',
  component: () => import('../components/pages/resetPwd.vue'),
  meta: { public: true },
  props: true
},
       {
  path: '/reset-verify',
  name: 'reset-verify',
  component: () => import('../components/pages/ResetVerify.vue'),
  meta: { public: true },
  props: true
},
       {
  path: '/rentals',
  name: 'rentals',
  component: () => import('../components/pages/rentals.vue'),
  meta: { public: true },
  props: true
},
       {
  path: '/jobs',
  name: 'jobs',
  component: () => import('../components/pages/jobs.vue'),
  meta: { public: true },
  props: true
},
   {
  path: '/services',
  name: 'services',
  component: () => import('../components/pages/services.vue'),
  meta: { public: true },
  props: true
},
    {
  path: '/sale',
  name: 'sale',
  component: () => import('../components/pages/sale.vue'),
  meta: { public: true },
  props: true
},
  {
  path: '/events',
  name: 'events',
  component: () => import('../components/pages/events.vue'),
  meta: { public: true },
  props: true
},
 
 
    {
      path: '/PostEditPage',
      
      component: () => import('../components/pages/PostEditPage.vue'),
      children: [
        {
          path: '/PostEditPage',
          name: 'PostEditPage',
          component: () => import('../components/pages/PostEditPage.vue'),
          meta: {
            requiresAuth: true
          },
          props: true
        }
      ]
    },
     {
      path: '/view-post',
      
      component: ViewAds,
      children: [
        {
          path: '/view-post/:serviceName',
          name: 'view-post',
          component: () => import('../components/pages/ViewAds.vue'),
          meta: {
            public: true
          },
          props: true
        }
      ]
    },
     {
      path: '/my-post',
      
      component: () => import('../components/pages/Mypost.vue'),
      children: [
        {
          path: '/my-post',
          name: 'my-post',
          component: () => import('../components/pages/Mypost.vue'),
          meta: {
            public: true
          },
          props: true
        }
      ]
    },
     {
      path: '/FloatingView',
      
      component: () => import('../components/pages/SendResponse.vue'),
      children: [
        {
          path: '/FloatingView',
          name: 'FloatingView',
          component: () => import('../components/pages/SendResponse.vue'),
          meta: {
            public: true
          },
          props: true
        }
      ]
    },
    {
      path: '/messages',
      
      component: () => import('@/components/pages/Message.vue'),
      children: [
        {
          path: '/messages',
          name: 'Messages',
          component: () => import('../components/pages/Message.vue'),
          meta: {
            requiresAuth: true
          },
          props: true
        }
      ]
    },
    {
      path: '/business/:slug',
      name: 'BusinessProfile',
      component: () => import('@/components/pages/ViewBusinessProfile.vue'),
      meta: { public: true },
      props: route => ({ slug: route.params.slug })
    },

 {
      path: '/new-post',
      
      component: () => import('@/components/pages/NewPostPage.vue'),
      children: [
        {
          path: '/new-post',
          name: 'new-post',
          component: () => import('../components/pages/NewPostPage.vue'),
          meta: {
            requiresAuth: true
          },
          props: true
        }
      ]
    },
     {
      path: '/edit-post',
      
      component: () => import('@/components/pages/EditPostPage.vue'),
      children: [
        {
          path: '/edit-post',
          name: 'edit-post',
          component: () => import('../components/pages/EditPostPage.vue'),
          meta: {
            requiresAuth: true
          },
          props: true
        }
      ]
    },
     {
      path: '/view-profile',
      
      component: () => import('@/components/pages/ViewProfile.vue'),
      children: [
        {
          path: '/view-profile',
          name: 'view-profile',
          component: () => import('../components/pages/ViewProfile.vue'),
          meta: {
            public: true
          },
          props: true
        }
      ]
    },

     {
      path: '/profile',
      
      component: () => import('@/components/pages/DropdownProfileview.vue'),
      children: [
        {
          path: '/profile',
          name: 'profile',
          component: () => import('../components/pages/DropdownProfileview.vue'),
          meta: {
            requiresAuth: true
          },
          props: true
        }
      ]
    },

     {
      path: '/my-pass',
      
      component: () => import('../components/pages/DropdownPasswordview.vue'),
      children: [
        {
          path: '/my-pass',
          name: 'my-pass',
          component: () => import('../components/pages/DropdownPasswordview.vue'),
          meta: {
            requiresAuth: true
          },
          props: true
        }
      ]
    },

    {
      path: '/analytics',
      name: 'analytics',
      component: () => import('../components/pages/AnalyticsDashboard.vue'),
      meta: { requiresAuth: true },
      props: true,
    },

     {
      path: '/my-adds',

      component: () => import('@/components/pages/DropdownMyadds.vue'),
      children: [
        {
          path: '/my-adds',
          name: 'my-adds',
          component: () => import('../components/pages/DropdownMyadds.vue'),
          meta: {
            requiresAuth: true
          },
          props: true
        }
      ]
    },
     {
      path: '/Favorites',
      
      component: () => import('@/components/pages/Favorites.vue'),
      children: [
        {
          path: '/Favorites',
          name: 'Favorites',
          component: () => import('../components/pages/Favorites.vue'),
          meta: {
            requiresAuth: true
          },
          props: true
        }
      ]
    },

     {
      path: '/sendResponseLoginModal',
      
      component: () => import('@/components/pages/Models/sendResponseLoginModal.vue'),
      children: [
        {
          path: '/sendResponseLoginModal',
          name: 'sendResponseLoginModal',
          component: () => import('../components/pages/Models/sendResponseLoginModal.vue'),
          meta: {
            public: true
          },
          props: true
        }
      ]
    },
    
    // {
    //   path: '/contact-us',
      
    //   component: () => import('@/components/pages/Models/contactUs.vue'),
    //   children: [
    //     {
    //       path: '/contact-us',
    //       name: 'contact-us',
    //       component: () => import('../components/pages/Models/ContactPage.vue'),
    //       meta: {
    //         public: true
    //       },
    //       props: true
    //     }
    //   ]
    // },
    {
  path: '/contact-us',
  name: 'contact-us',
  component: () => import('../components/pages/Models/ContactPage.vue'),
  meta: { public: true },
  props: true
},

     {
      path: '/super',
      
      component: () => import('@/components/pages/adminForm.vue'),
      children: [
        {
          path: '/super',
          name: 'super',
          component: () => import('../components/pages/adminForm.vue'),
          meta: {
            requiresAdmin: true
          },
          props: true
        }
      ]
    },
      {
      path: '/verify-user',
     
      component: () => import('@/components/verify.vue'),
      children: [
        {
          path: '/verify-user',
          name: 'verifyComponent',
          component: () => import('../components/verify.vue'),
          meta: {
            public: true
          },
          props: true
        }
      ]
    },
    {
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      component: () => import('@/components/pages/TermsAndConditions.vue'),
      meta: { public: true }
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('@/components/pages/PrivacyPolicy.vue'),
      meta: { public: true }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../components/pages/About.vue'),
      meta: { public: true }
    },
    {
      path: '/why-renants',
      name: 'why-renants',
      component: () => import('@/components/pages/WhyRenants.vue'),
      meta: { public: true }
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import('../components/pages/PricingPage.vue'),
      meta: { public: true }
    },
    {
      // One-click renew from the ad expiry emails (token in ?token=, no login)
      path: '/renew-ad',
      name: 'renew-ad',
      component: () => import('../components/pages/RenewAd.vue'),
      meta: { public: true }
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: () => import('../components/pages/CheckoutPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/checkout/return',
      name: 'checkout-return',
      component: () => import('../components/pages/CheckoutPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/service-audit',
      name: 'service-audit',
      component: () => import('@/components/pages/ServiceAudit.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/service-audit/:servicesID',
      name: 'service-audit-by-id',
      component: () => import('@/components/pages/ServiceAudit.vue'),
      meta: { requiresAdmin: true },
      props: true
    },
    {
      path: '/all-services',
      name: 'all-services',
      component: () => import('@/components/pages/AllServices.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/metadata',
      name: 'metadata-admin',
      component: () => import('@/components/pages/MetadataAdmin.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/plan-upgrade-report',
      name: 'plan-upgrade-report',
      component: () => import('@/components/pages/PlanUpgradeReport.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/expiring-subscriptions',
      name: 'expiring-subscriptions-report',
      component: () => import('@/components/pages/ExpiringSubscriptionsReport.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/citywise-metadata',
      name: 'citywise-metadata-admin',
      component: () => import('@/components/pages/CitywiseMetadataAdmin.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/impersonate',
      name: 'impersonation-admin',
      component: () => import('@/components/pages/ImpersonationAdmin.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/search-analytics',
      name: 'search-analytics',
      component: () => import('@/components/pages/SearchAnalytics.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/audit-log',
      name: 'admin-audit-log',
      component: () => import('@/components/pages/AdminAuditLog.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/interaction-analytics',
      name: 'interaction-analytics',
      component: () => import('@/components/pages/InteractionAnalytics.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/visitor-activity',
      name: 'visitor-activity',
      component: () => import('@/components/pages/VisitorActivity.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/feedback',
      name: 'admin-feedback',
      component: () => import('@/components/pages/FeedbackAdmin.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/directory-claims',
      name: 'admin-directory-claims',
      component: () => import('@/components/pages/DirectoryClaimsAdmin.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/business-listings',
      name: 'admin-business-listings',
      component: () => import('@/components/pages/BusinessListingsAdmin.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/admin/deals',
      name: 'admin-deals',
      component: () => import('@/components/pages/DealsAdmin.vue'),
      meta: { requiresAdmin: true }
    },
    {
      // Unified admin console: left-nav of every admin section, content on the
      // right. ?section=<key> deep-links / restores a specific pane.
      path: '/admin-console',
      name: 'admin-console',
      component: () => import('@/components/pages/AdminConsole.vue'),
      meta: { requiresAdmin: true }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        public: true
      }
    }
   
  ]
})

// Ask the user to sign in instead of silently bouncing them. App.vue hosts the
// login popup and listens for this event; after login, LoginModal navigates to
// localStorage.redirectTo. On a direct load (nothing rendered yet) we land on
// home so the popup has a page behind it; mid-app we just stay put.
function promptLogin(to: any, from: any, next: any) {
  try { localStorage.setItem('redirectTo', to.fullPath); } catch (e) { /* storage blocked */ }
  window.dispatchEvent(new CustomEvent('renants:open-login'));
  return from.matched.length ? next(false) : next('/');
}

// Page guards are UX only — every protected API enforces auth server-side.
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('auth-token');

  if (to.meta.requiresAdmin) {
    if (!token) return promptLogin(to, from, next);
    try {
      // Role comes from the DB via the verified token (the old check read it
      // from the anonymous /getoneusers, which any userID could satisfy).
      await axios.post('/api/check-admin');
      return next();
    } catch (error) {
      return next('/dashboard');
    }
  }

  if (to.meta.requiresAuth && !token) {
    return promptLogin(to, from, next);
  }

  next();
});

export default router

// ── Page-view tracking ──────────────────────────────────────────────────────
// Fire a fire-and-forget 'page-view' event on every navigation so the admin
// Interaction Analytics report can show which pages each user/IP visited and
// when — every listing, deal, /more category and the login screen included.
// The route name is the action; fullPath (label) carries the specific
// deal/category/listing slug. Never allowed to interfere with navigation.
// Admin/back-office pages are excluded — we only care about what real visitors
// browse, not admins clicking around their own console.
const ADMIN_PATH_PREFIXES = [
  '/admin', '/super', '/service-audit', '/all-services', '/crawl-report',
];
router.afterEach((to) => {
  try {
    const p = to.path || '';
    if (ADMIN_PATH_PREFIXES.some((pre) => p === pre || p.startsWith(pre))) return;
    trackInteraction('page-view', String(to.name || 'page'), { label: to.fullPath });
  } catch (_) {
    /* tracking must never break navigation */
  }
});

// Canonical URLs for specific routes
const canonicalRoutes = [
  '/events',
  '/sale',
  '/services',
  '/jobs',
  '/rentals',
  '/messages',
  '/contact-us',
  '/dashboard'
];

router.afterEach((to) => {
  // Only inject canonical in production
  if (import.meta.env.VITE_NODE_ENV === 'production') {
    const baseUrl = 'https://renants.com';
    let canonicalUrl = '';
    // Normalize path: remove trailing slash except for root
    let cleanPath = to.path.replace(/\/+$/, '') || '/';
    if (canonicalRoutes.includes(cleanPath)) {
      canonicalUrl = baseUrl + cleanPath;
    } else {
      canonicalUrl = baseUrl;
    }

    let link: HTMLLinkElement | null = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
  } else {
    // Remove canonical if present in non-production
    const link: HTMLLinkElement | null = document.querySelector("link[rel='canonical']");
    if (link) {
      link.parentNode?.removeChild(link);
    }
  }

  // Handle noindex for specific routes
  const noindexRoutes = [
    '/PostEditPage',
    '/FloatingView',
    '/edit-post',
    '/my-post',
    '/my-adds',
    '/view-profile',
    '/super',
    '/verify-user',
    '/messages'
  ];
  let robotsMeta: HTMLMetaElement | null = document.querySelector("meta[name='robots']");
  if (noindexRoutes.includes(to.path)) {
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', 'noindex');
  } else {
    if (robotsMeta) {
      robotsMeta.parentNode?.removeChild(robotsMeta);
    }
  }
});
